<script setup>
import { useMapGetter } from 'dashboard/composables/store';
import { computed } from 'vue';

const props = defineProps({
  /**
   * Conteúdo da célula
   */
  content: {
    type: [String, Number],
    default: '',
  },
  /**
   * Número máximo de caracteres antes de truncar
   */
  maxLength: {
    type: Number,
    default: 60,
  },
  /**
   * Número máximo de linhas
   */
  maxLines: {
    type: Number,
    default: 2,
  },
  /**
   * Sempre mostrar o conteúdo completo, sem truncar
   */
  noTruncate: {
    type: Boolean,
    default: false
  }
});

const isRTL = useMapGetter('accounts/isRTL');

const formattedContent = computed(() => {
  if (!props.content || props.noTruncate) return props.content;
  
  const content = String(props.content);
  return content.length > props.maxLength 
    ? content.slice(0, props.maxLength) + '...' 
    : content;
});

const shouldAddTooltip = computed(() => {
  if (!props.content) return false;
  const content = String(props.content);
  return content.length > props.maxLength;
});
</script>

<template>
  <div
    class="cell-content"
    :class="{ 
      'text-right': isRTL,
      'truncate-cell': !noTruncate
    }"
    :title="shouldAddTooltip ? content : null"
  >
    <slot v-if="$slots.default || content">
      <template v-if="content">{{ formattedContent }}</template>
    </slot>
    <span v-else class="text-slate-300 dark:text-slate-700">---</span>
  </div>
</template>

<style scoped>
.cell-content {
  overflow: hidden;
  max-width: 100%;
}

.truncate-cell {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: v-bind('maxLines');
  overflow: hidden;
  word-break: break-word;
  text-overflow: ellipsis;
}
</style>